export default "__VITE_ASSET__CiYQT5xg__"